var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37678 13.3484C3.46465 12.3119 1.88495 12.2111 0.84843 13.1232C-0.188089 14.0354 -0.288921 15.6151 0.623216 16.6516L4.37678 13.3484ZM13.5 27.5L11.6232 29.1516C12.1114 29.7063 12.8199 30.0166 13.5586 29.9993C14.2974 29.982 14.9906 29.6387 15.4522 29.0617L13.5 27.5ZM35.4522 4.06174C36.3147 2.98358 36.1399 1.41035 35.0617 0.547828C33.9836 -0.314696 32.4104 -0.139892 31.5478 0.938262L35.4522 4.06174ZM0.623216 16.6516L11.6232 29.1516L15.3768 25.8484L4.37678 13.3484L0.623216 16.6516ZM15.4522 29.0617L35.4522 4.06174L31.5478 0.938262L11.5478 25.9383L15.4522 29.0617Z",
    fill: "#F5F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/checkWhite.c11f2455d7e9c47ab289341bdb0f4660.svg";
export { ForwardRef as ReactComponent };